import axios from 'axios';
import useTokenStore from '@store/token-store/token.store';
import { getHotelWifiApiBaseUrl } from '@shared/config/runtime-config';

const hotelWifiAxiosInstance = axios.create({
  headers: {
    'Content-Type': 'application/json'
  }
});

hotelWifiAxiosInstance.interceptors.request.use(
  (config) => {
    if (!config.baseURL) {
      config.baseURL = getHotelWifiApiBaseUrl();
    }

    const { accessToken } = useTokenStore.getState();
    if (accessToken) {
      config.headers.Authorization = `Bearer ${accessToken}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

hotelWifiAxiosInstance.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject(error)
);

export default hotelWifiAxiosInstance;
